import MenuIcon from '@mui/icons-material/Menu'
import { AppBar, Box, IconButton, Link, Stack, Toolbar, useMediaQuery, useTheme } from '@mui/material'
import NextLink from 'next/link'
import { pagesPath, staticPath } from '~/lib/$path'
import { theme } from '~/lib/theme'
import { UserInfo } from './UserInfo'
import { UserMenu } from './UserMenu'
import { HelpButton } from '~/components/common/HelpButton'
import { StartGuideButton } from '~/components/common/StartGuideButton'

type Props = {
  drawerOpen: boolean
  onDrawerOpen?: () => void
  bannerHeight?: string
  bannerOpen?: boolean
}

export const AppHeader = ({ drawerOpen, onDrawerOpen, bannerHeight, bannerOpen = false }: Props) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <AppBar
      sx={{
        // TODO: Designシステムに色が存在しない。デザイナーと後で詰める
        backgroundColor: isMobile ? 'white' : '#003C80',
        position: 'fixed',
        boxShadow: 'none',
        borderBottom: '1px solid',
        borderColor: 'divider',
        top: bannerOpen ? bannerHeight : 0,
      }}
    >
      <Toolbar sx={{ justifyContent: 'space-between' }}>
        {drawerOpen ? (
          <Box sx={{ flexGrow: 1 }} />
        ) : (
          <>
            <IconButton
              color="inherit"
              onClick={onDrawerOpen}
              edge="start"
              size="large"
              sx={{ color: isMobile ? 'primary.toridoriMain' : 'white' }}
            >
              <MenuIcon />
            </IconButton>
            <NextLink href={pagesPath.home.$url()} passHref legacyBehavior>
              <Link
                sx={{
                  lineHeight: 1,
                  height: {
                    xs: 20,
                    sm: 24,
                  },
                  ml: 1,
                  flexGrow: isMobile ? 0 : 1,
                }}
              >
                <img
                  src={isMobile ? staticPath.toridori_marketing_logo_1_png : staticPath.toridori_marketing_1_dark_png}
                  alt="トリドリマーケティング"
                  style={{ height: '100%', objectFit: 'contain' }}
                />
              </Link>
            </NextLink>
          </>
        )}

        <Stack
          sx={{
            gap: { xs: 0, sm: 2 },
          }}
          direction="row"
          alignItems="center"
        >
          <HelpButton />

          {/* お客様情報 */}
          <Stack gap={1} direction="row" alignItems="center">
            {!isMobile && <UserInfo />}
            <UserMenu />
          </Stack>
        </Stack>
      </Toolbar>
    </AppBar>
  )
}

export default function useAppBarHeight(): number {
  const {
    mixins: { toolbar },
    breakpoints,
  } = useTheme()
  const toolbarDesktopQuery = breakpoints.up('sm')
  const toolbarLandscapeQuery = `${breakpoints.up('xs')} and (orientation: landscape)`
  const isDesktop = useMediaQuery(toolbarDesktopQuery)
  const isLandscape = useMediaQuery(toolbarLandscapeQuery)
  let currentToolbarMinHeight
  if (isDesktop) {
    currentToolbarMinHeight = toolbar[toolbarDesktopQuery]
  } else if (isLandscape) {
    currentToolbarMinHeight = toolbar[toolbarLandscapeQuery]
  } else {
    currentToolbarMinHeight = toolbar
  }
  return (currentToolbarMinHeight as { minHeight?: number } | undefined)?.minHeight ?? 56
}
